import { useState } from 'react';
import { Text } from '@chakra-ui/react';
import style from './CommentItem.module.css';
interface CommentTextProps {
  body: string;
  maxDisplayLength: number;
}
const CommentText = ({
  body,
  maxDisplayLength
}: CommentTextProps) => {
  const [isFullTextVisible, setFullTextVisible] = useState(false);
  const truncatedText = body.slice(0, maxDisplayLength);
  const displayText = isFullTextVisible ? body : truncatedText;
  const toggleReadMore = () => {
    setFullTextVisible(!isFullTextVisible);
  };
  return <Text fontSize="sm" className={style.commentText} data-sentry-element="Text" data-sentry-component="CommentText" data-sentry-source-file="CommentText.tsx">
      {displayText}
      {` `}
      {body.length > maxDisplayLength && <button className={style.seeMoreButton} onClick={toggleReadMore}>
          <Text>{isFullTextVisible ? 'See Less' : 'See More'}</Text>
        </button>}
    </Text>;
};
export default CommentText;